import ninjaApi from 'store/redux/apis/ninja.api';

/**
 * Woocommerce connection api
 */
export const woocommerceApi = ninjaApi.injectEndpoints({
  overrideExisting: true,
  tagTypes: ['Woocommerce', 'Integrations'],
  endpoints: (build) => ({
    checkWoocommerceStoreUrl: build.mutation({
      query: (data) => ({
        url: '/apps/woocommerce/check-domain',
        method: 'POST',
        data,
      }),
    }),
    requestWoocommerceAuthorization: build.mutation({
      query: (data) => ({
        url: '/apps/woocommerce/request-authorization',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Woocommerce', 'Integrations'],
    }),
    integrateWoocommerceStore: build.mutation({
      query: (data) => ({
        url: '/apps/woocommerce/integrate',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Woocommerce'],
    }),
    woocommerceDashboardWidget: build.query({
      query: (data) => ({
        url: '/apps/woocommerce/widget',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Woocommerce'],
    }),
  }),
});

export const {
  useCheckWoocommerceStoreUrlMutation,
  useRequestWoocommerceAuthorizationMutation,
  useIntegrateWoocommerceStoreMutation,
  useWoocommerceDashboardWidgetQuery,
} = woocommerceApi;
